import { defineComponent as _defineComponent } from 'vue'
import { useRouter } from 'vue-router/composables';

import { Row, InitialAvatarIcon } from '@warrenbrasil/nebraska-web';

interface Props {
  portfolioId: string;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'PerformanceLink',
  props: {
    portfolioId: null
  },
  setup(__props: any) {

const props = __props as {
  portfolioId: string;
}



const router = useRouter();

const handleClick = () => {
  router.push({
    name: 'wealthPerformanceV2',
    params: { portfolioId: props.portfolioId }
  });
};

return { __sfc: true,props, router, handleClick, Row, InitialAvatarIcon }
}

})